module.exports = __webpack_public_path__ + "static/media/Icon-repair.0903eaf6.svg";